import ROUTES, { generatePath } from '../../../../utils/routes';

const PlayerDetailsLink = props => {
    const { customerId } = props;

    const onPlayerLink = e => {
        e.stopPropagation();
        window.open(generatePath(ROUTES.PLAYER_DETAILS.path, { customerId }));
    };

    return <a onClick={onPlayerLink}>{customerId}</a>;
};

export default PlayerDetailsLink;
